import React, {useRef} from 'react'
import { Container, Header , Tab, Item, Grid} from 'semantic-ui-react'
import "./Section5.css"

const Section5 = () => {
    const ref = useRef(null);

    const scrollHandler = (scrollOffset) => {
        ref.current.scrollLeft += scrollOffset;
      };
      
      const listOfCities = [
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
          ["Phoenix","Arizona"],
          ["Hot Springs","Arkansas"],
    ]
    const content = <Grid columns={4}>
            {
                listOfCities.map((city,index)=>{
                    return <Grid.Column key={index}>
                    <Item.Group><Item >
                    <Item.Content  as='a'>
                        <Item.Content className="text-black" verticalAlign='middle'>{city[0]}</Item.Content>
                        <Item.Content className="text-grey" verticalAlign='middle'>{city[1]}</Item.Content>
                    </Item.Content>
                    </Item></Item.Group>
                        </Grid.Column>
                })
            }
        </Grid>
    const panes = [
        {
            menuItem: 'Destinations for arts & culture',
            render: () => <Tab.Pane attached={false}>
                {content}
          </Tab.Pane>,
        },
        {
            menuItem: 'Destinations for outdoor adventure',
            render: () => <Tab.Pane attached={false}>{content}</Tab.Pane>,
        },
        {
            menuItem: 'Mountain cabins',
            render: () => <Tab.Pane attached={false}>{content}</Tab.Pane>,
        }
      ]
    return <Container className="Section5 p-1">
        <Header className="p-1-t p-1-b" size='huge'>Inspiration for future getaways</Header>
        <Tab className="border-none" menu={{ secondary: true, pointing: true }} panes={panes} />
    </Container>
}
 export default Section5